module.exports = __webpack_public_path__ + "img/onboarding_icon_3.80655a02.svg";